import Image from 'next/image'

import styles from './styles.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark, faEye, faShare, faXmark } from '@fortawesome/free-solid-svg-icons'

import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner'

import { useSession } from 'next-auth/react'
import axios from 'axios'
import { PuffLoader, PulseLoader } from 'react-spinners'

import errorMsg from '../../../Functions/errorMsg'
import successMsg from '../../../Functions/successMsg'

import EventListing from '../EventListing/EventListing'
import infoMsg from '../../../Functions/infoMsg'

export default function SavedEvents({ setNavCategory, setPendingRequest }) {

  const { data: session, status } = useSession();

  const [initialLoading, setInitialLoading] = useState(null);
  const [watchingListings, setWatchingListings] = useState(null);

  useEffect(() => {
    if(initialLoading !== null) return;
    if(watchingListings !== null) return;
    if(status === 'loading') return;
    if(!session) return;

    async function getMyListings() {
        setInitialLoading(true);
        setPendingRequest(true);

        const result = await axios.post(`${window.location.origin}/api/eventHub/savedEvents`, {
          userID: session.user.token.id
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
        })

        if(result && result.status === 200) {
          const data = result.data;
          setWatchingListings(data);
        }

        setPendingRequest(false);

    }

    getMyListings();

  }, [session, status])

  function isLoading() {
    if(status === 'loading') return true;
    if(initialLoading === false || initialLoading === null) return true;
    if(watchingListings === null) return true;
    return false;
  }

  function handleWatch(type, listingID, username) {
    if(type === 'remove') {
      const listingPos = watchingListings.findIndex((listing) => listing._id === listingID);
      if(listingPos > -1) {
        const updatedWatchlist = [...watchingListings];
        updatedWatchlist[listingPos].watching.filter((user) => user !== username);
        setWatchingListings(updatedWatchlist);

      } else {
        errorMsg("Oops! We could not remove this listing, try refreshing the page.");
      }
    }
    if(type === 'add') {
      const listingPos = watchingListings.findIndex((listing) => listing._id === listingID);
      if(listingPos > -1) {
        const updatedWatchlist = [...watchingListings];
        updatedWatchlist[listingPos].watching.push(username);
        setWatchingListings(updatedWatchlist);

      } else {
        errorMsg("Oops! We could not remove this listing, try refreshing the page.");
      }
    }
  }

  const [viewEventData, setViewEventData] = useState(null); // ListingID Stored

  return (
    <section id={styles.wrapper}>
      { viewEventData !== null && <EventListing listingID={viewEventData} closeListing={setViewEventData} /> }

      { isLoading() === true && <section id={styles.loading}><PulseLoader size={30} color='#154734' /></section> }

      { isLoading() === false && (watchingListings.length === 0 ?
        <div id={styles.noListings}>
          <h1>Your watchlist is empty</h1>
        </div>
        :
        <section id={styles.container}>
          {
            watchingListings.map((listing, index) => {
              return <ListingCard key={index} session={session} listing={listing} setViewEventData={setViewEventData} handleWatch={handleWatch} />
            })
          }
        </section>
      )}

  </section>
  )
}

const ListingCard = ({ session, listing, setViewEventData, handleWatch }) => {

  const username = session.user.token.username;

  const [coverLoaded, setCoverLoaded] = useState(false);
  const getCover = listing.images.findIndex((images) => images.position === 1);

  const [watching, setWatching] = useState(listing.watching.includes(username));

  const [watchPending, setWatchPending] = useState(false);
  
  const listingID = listing._id;

  const listArea = listing.listArea;

  const [timeStamps, setTimeStamps] = useState(listing !== null && listing !== undefined && getTimeStamp(listing));

  useEffect(() => {
    if(listing === null || listing === undefined) return;

    const countdownInterval = setInterval(() => {

      const timestamp = getTimeStamp(listing);
      if(timestamp.status === 'Garage Sale Ended') {
        closeCountdown();
      }
      setTimeStamps(timestamp);
    }, 100);

    function closeCountdown() {
      clearInterval(countdownInterval);
    }

    return () => {
      clearInterval(countdownInterval)
    }

  }, [])

  async function apiHandleWatch() {
    if(watchPending === true) return;
    setWatchPending(true);
    
    const type = watching === true ? 'remove' : 'add';

    if(type === "remove") {
      const result = await axios.post(`${window.location.origin}/api/eventHub/watch-methods/unwatch`, {
        listingID: listingID,
        username: username,
      }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString());
        setWatchPending(false)
      })
  
      if(result && result.status === 200) {
        setWatchPending(false)
        handleWatch('remove', listingID, username);
        successMsg("Listing unsaved.");
        setWatching(false);
      }
    }

    if(type === "add") {
      const result = await axios.post(`${window.location.origin}/api/eventHub/watch-methods/watch`, {
        listingID: listingID,
        username: username,
      }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString());
        setWatchPending(false)
      })
  
      if(result && result.status === 200) {
        setWatchPending(false)
        handleWatch('add', listingID, username);
        successMsg("Listing unsaved.");
        setWatching(true);
      }
    }


  }


  function isSoldOut() {
    if(!listing.acceptPayments.enabled) return;
    if (listing && Array.isArray(listing.acceptPayments.purchaseOptions)) {
        return listing.acceptPayments.purchaseOptions.every(option => option.availableQuantity === 0);
    }
    return false;
  }

  function almostSoldOut() {
    if(!listing.acceptPayments.enabled) return;
      if (listing && Array.isArray(listing.acceptPayments.purchaseOptions)) {
          const totalAvailable = listing.acceptPayments.purchaseOptions.reduce((acc, option) => {
              if (option.availableQuantity >= 1 && option.availableQuantity <= 4) {
                  return acc + option.availableQuantity;
              }
              return acc;
          }, 0);
          return totalAvailable >= 1 && totalAvailable <= 4;
      }
      return false;
  }

  return (
    <div className={styles.card}>

      <div>
        <h1>{listArea === 'General' ? `${listing.category}` : listArea} Event</h1>
        { isSoldOut() === true && <h1 className={styles.soldOut}>Sold Out</h1> }
        { almostSoldOut() === true && <h1 className={styles.almostSoldOut}>Limited Tickets</h1> }

      </div>

     <section>
        <div style={{display: coverLoaded === false ? 'flex' : 'none'}}> <LoadingSpinner type="pulse" color="#154734" /></div>
        <Image sizes='auto auto' fill src={listing.images[getCover].url} alt={listing.images[getCover].url} onLoadingComplete={() => setCoverLoaded(true)} />
      </section>
      <section>
        <div>
          <h1>{listing.title}</h1>
        </div>

        <div>
          <motion.button onClick={() => setViewEventData(listingID)}><FontAwesomeIcon icon={faEye} id={styles.icon} /></motion.button>

          <motion.button onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/?popup=sharedEvent&_id=${listing._id}`); infoMsg("Link Copied") } }><FontAwesomeIcon icon={faShare} id={styles.icon} /></motion.button>

          <motion.button onClick={() => apiHandleWatch()}>
            { watchPending === false && <>
              <FontAwesomeIcon style={{marginRight: watching === true ? '8px' : '0px'}} icon={faBookmark} id={styles.icon} />
              { watching === true && <FontAwesomeIcon icon={faXmark} id={styles.icon2} /> }
            </> }
            { watchPending === true && <PuffLoader size={25} color='black' /> }
          </motion.button>
        </div>

      </section>
    </div>
  )
}

function getTimeStamp(data) {

  const starting = new Date(Date.parse(data.startDate));
  const ending = new Date(Date.parse(data.endDate));
  const current = new Date();

  var years;
  var months;
  var weeks;
  var days;
  var hours;
  var minutes;
  var seconds;
  var status;

  if(current < starting) {
    const dif = Math.abs((starting.getTime() - current.getTime()) / 1000)
    years = Math.floor(dif / 31536000);
    months = Math.floor((dif % 31536000) / 2628000);
    weeks = Math.floor(dif / 31536000);
    days = Math.floor(dif / (3600 * 24));
    hours = Math.floor(dif % (3600*24) / 3600);
    minutes = Math.floor(dif % 3600 / 60);
    seconds = Math.floor(dif % 60);
    status = "Garage Sale Scheduled..."
  } else if(current >= starting && current <= ending) {
    const dif = Math.abs((ending.getTime() - current.getTime()) / 1000)
    years = Math.floor(dif / 31536000);
    months = Math.floor((dif % 31536000) / 2628000);
    weeks = Math.floor(dif / 31536000);
    days = Math.floor(dif / (3600 * 24));
    hours = Math.floor(dif % (3600*24) / 3600);
    minutes = Math.floor(dif % 3600 / 60);
    seconds = Math.floor(dif % 60);
    status = "Garage Sale Active"
  } else if(current >= ending) {
    years = 0;
    months = 0;
    weeks = 0;
    days = 0;
    hours = 0;
    minutes = 0;
    seconds = 0;
    status = "Garage Sale Ended";
  }

  return { years, months, weeks, days, hours, minutes, seconds, status }
}